import { c as _c } from "react/compiler-runtime";
import { capitalize, Divider, Popover, Stack, Typography } from '@mui/material';
import { ConditionOperatorEnum } from '@repo/api-gw-sdk';
import { useEffect, useMemo, useState } from 'react';
import { OPERATORS } from '@/components/conditions/OperatorSelect';
import { ConditionPanelTriggerButton, MultiSelectConditionPanel } from '@/components/conditions/conditionComponents';
import { SelectedItemsBody } from '@/components/panels/selectionPanel/selectedItemsBody';
import { SelectedItemsHeader } from '@/components/panels/selectionPanel/selectedItemsHeader';
import { SearchBar } from '@/components/search/searchBar';
import { isValueCondition, type MultiSelectConditionComponentProps } from '@/types/advanceFilter';
import { useDebouncedValue } from '@/utils/useDebouncedValue';
import { useResourceIdentifiers } from '../useResourceIentifiers';
export const ResourceNameCondition = props => {
  const $ = _c(4);
  if (props.condition.operator === ConditionOperatorEnum.In || props.condition.operator === ConditionOperatorEnum.NotIn) {
    let t0;
    if ($[0] !== props) {
      t0 = <ResourceNameSelection {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <ResourceNameManualSelection entityName="resource name" {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
const ResourceNameSelection = props => {
  const $ = _c(9);
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebouncedValue(searchText, 300);
  const {
    data: body,
    isLoading
  } = useResourceIdentifiers(props.supportedProviders, props.supportedResourceTypes, debouncedSearch || undefined);
  let t0;
  if ($[0] !== body?.resources) {
    t0 = Array.from(new Set((body?.resources || []).map(_temp))).sort().map(_temp2);
    $[0] = body?.resources;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const names = t0;
  let t1;
  if ($[2] !== props) {
    t1 = () => {
      setSearchText("");
      props.onClose?.();
    };
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isLoading || $[5] !== names || $[6] !== props || $[7] !== t1) {
    t2 = <MultiSelectConditionPanel showAddNewButton={true} showSearchBox={true} isLoading={isLoading} entityName="name" options={names} onSearchChange={setSearchText} {...props} onClose={t1} />;
    $[4] = isLoading;
    $[5] = names;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
const ResourceNameManualSelection = props => {
  const $ = _c(45);
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(props.popoverOpen || false);
  const [valueFilter, setValueFilter] = useState("");
  const [isScrolledVertically, setScrolledVertically] = useState(false);
  let t0;
  let t1;
  if ($[0] !== props.popoverOpen) {
    t0 = () => {
      if (props.popoverOpen !== undefined) {
        setPopoverOpen(props.popoverOpen);
      }
    };
    t1 = [props.popoverOpen];
    $[0] = props.popoverOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== props.condition) {
    t2 = isValueCondition(props.condition) && props.condition?.value || [];
    $[3] = props.condition;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selectedValues = t2;
  let t3;
  if ($[5] !== selectedValues) {
    t3 = selectedValues.map(_temp3);
    $[5] = selectedValues;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const options = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setPopoverOpen(true);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== options || $[9] !== props.shouldShowId || $[10] !== props.useImagesInSelectedView || $[11] !== selectedValues) {
    t5 = <ConditionPanelTriggerButton ref={setAnchorEl} onClick={t4} useImagesInSelectedView={props.useImagesInSelectedView} shouldShowId={props.shouldShowId} options={options} selectedValues={selectedValues} />;
    $[8] = options;
    $[9] = props.shouldShowId;
    $[10] = props.useImagesInSelectedView;
    $[11] = selectedValues;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props) {
    t6 = () => {
      setPopoverOpen(false);
      props.onClose?.();
    };
    $[13] = props;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = `Add one or more ${props.entityName}s`;
  let t9;
  if ($[16] !== t8) {
    t9 = <Typography className="my-[12px]" variant="body1">{t8}</Typography>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = `${props.property?.policyRelation && OPERATORS[props.property.policyRelation]?.[props.condition.operator as ConditionOperatorEnum]?.label}...`;
  let t11;
  if ($[18] !== t10) {
    t11 = capitalize(t10);
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== props) {
    t12 = value_0 => {
      props.onChange({
        ...props.condition,
        value: value_0
      });
    };
    $[20] = props;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== selectedValues || $[23] !== t11 || $[24] !== t12 || $[25] !== valueFilter) {
    t13 = <SearchBar hideSearchIcon={true} value={valueFilter} setValue={setValueFilter} placeholder={t11} selectedValues={selectedValues} onAddClick={t12} showAddButton={true} />;
    $[22] = selectedValues;
    $[23] = t11;
    $[24] = t12;
    $[25] = valueFilter;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t9) {
    t14 = <Stack className="px-[24px] py-[12px]" sx={t7}>{t9}{t13}</Stack>;
    $[27] = t13;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isScrolledVertically || $[31] !== props || $[32] !== selectedValues) {
    t15 = selectedValues.length > 0 && <><Divider /><Stack sx={{
        overflow: "hidden",
        flexGrow: 1
      }}><Stack className="py-[12px] px-[24px]" sx={{
          boxShadow: isScrolledVertically ? "var(--mui-customShadows-panel)" : undefined,
          "& .MuiTypography-root": {
            fontWeight: "bold"
          }
        }}><SelectedItemsHeader title={`${selectedValues.length} value${selectedValues.length === 1 ? "" : "s"} added`} clearAll={() => props.onChange({
            ...props.condition,
            value: []
          })} /></Stack><Divider /><SelectedItemsBody items={selectedValues} renderItem={_temp4} itemKey={_temp5} onRemove={item_1 => {
          props.onChange({
            ...props.condition,
            value: selectedValues.filter(i => i !== item_1)
          });
        }} onScrollVerticallyChange={setScrolledVertically} /></Stack></>;
    $[30] = isScrolledVertically;
    $[31] = props;
    $[32] = selectedValues;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <Stack className="w-[308px] max-h-[480px] overflow-hidden">{t14}{t15}</Stack>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== anchorEl || $[38] !== popoverOpen || $[39] !== t16 || $[40] !== t6) {
    t17 = <Popover open={popoverOpen} anchorEl={anchorEl} onClose={t6}>{t16}</Popover>;
    $[37] = anchorEl;
    $[38] = popoverOpen;
    $[39] = t16;
    $[40] = t6;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t17 || $[43] !== t5) {
    t18 = <>{t5}{t17}</>;
    $[42] = t17;
    $[43] = t5;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};
function _temp(x) {
  return x.name;
}
function _temp2(x_0) {
  return {
    id: x_0,
    name: x_0
  };
}
function _temp3(value) {
  return {
    id: value,
    name: value
  };
}
function _temp4(item) {
  return item;
}
function _temp5(item_0) {
  return item_0;
}